<template>
  <button class="toggle-btn" :class="`${type} ${isOpen ? 'open' : ''}`" @click="$emit('onClick')">
    <span class="icon-left" />
    <span class="icon-right" />
  </button>
</template>

<script>
export default {
  props: {
    type: {
      default: 'mobile',
      type: String
    },
    isOpen: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">

.toggle-btn {
  width: 40px;
  height: 40px;
  transition-duration: 0.5s;
  border: 0;
  background: transparent;
  position: relative;
}
.toggle-btn .icon-left {
  transition-duration: 0.5s;
  position: absolute;
  height: 2px;
  width: 11px;
  top: 18px;
  left: 7px;
}
.toggle-btn .icon-left:before {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  content: "";
  top: -7px;
  left: 0;
}
.toggle-btn .icon-left:after {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  content: "";
  top: 7px;
  left: 0;
}
.toggle-btn .icon-left:hover {
  cursor: pointer;
}
.toggle-btn .icon-right {
  transition-duration: 0.5s;
  position: absolute;
  height: 2px;
  width: 11px;
  top: 18px;
  left: 18px;
}
.toggle-btn .icon-right:before {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  content: "";
  top: -7px;
  left: 0;
}
.toggle-btn .icon-right:after {
  transition-duration: 0.5s;
  position: absolute;
  width: 11px;
  height: 2px;
  content: "";
  top: 7px;
  left: 0;
}
.toggle-btn .icon-right:hover {
  cursor: pointer;
}

.toggle-btn:hover {
  cursor: pointer;
}

.mobile {
  &.toggle-btn .icon-left,
  &.toggle-btn .icon-left:before ,
  &.toggle-btn .icon-left:after ,
  &.toggle-btn .icon-right ,
  &.toggle-btn .icon-right:before ,
  &.toggle-btn .icon-right:after  {
    background-color: white;
  }
  &.toggle-btn.open .icon-left {
    transition-duration: 0.5s;
    background: transparent;
  }
  &.toggle-btn.open .icon-left:before {
    transform: rotateZ(45deg) scaleX(1.4) translate(2px, 1px);
  }
  &.toggle-btn.open .icon-left:after {
    transform: rotateZ(-45deg) scaleX(1.4) translate(2px, -1px);
  }
  &.toggle-btn.open .icon-right {
    transition-duration: 0.5s;
    background: transparent;
  }
  &.toggle-btn.open .icon-right:before {
    transform: rotateZ(-45deg) scaleX(1.4) translate(-2px, 1px);
  }
  &.toggle-btn.open .icon-right:after {
    transform: rotateZ(45deg) scaleX(1.4) translate(-2px, -1px);
  }
}

.desktop {
  &.toggle-btn .icon-left,
  &.toggle-btn .icon-left:before ,
  &.toggle-btn .icon-left:after ,
  &.toggle-btn .icon-right ,
  &.toggle-btn .icon-right:before ,
  &.toggle-btn .icon-right:after  {
    background-color: $deepBlue;
  }
  &.toggle-btn.open .icon-left {
    transition-duration: 0.5s;
  }
  &.toggle-btn.open .icon-left:before {
    left: 10px;
  }
  &.toggle-btn.open .icon-left:after {
    left: -10px;
  }
  &.toggle-btn.open .icon-right {
    transition-duration: 0.5s;
  }
  &.toggle-btn.open .icon-right:before {
    left: 10px;
  }
  &.toggle-btn.open .icon-right:after {
    left: -10px;
  }
}

</style>
